/** Per-store themes — applied in the admin app (/app) only. */

export const DEFAULT_STORE_THEME = "vastrakiran";

export const STORE_THEMES = [
  {
    id: "royal_maroon",
    name: "Royal Maroon + Gold",
    description: "Silk saree boutique",
    primary: "#8B1E3F",
    accent: "#C89B3C",
    background: "#F6F2EB",
  },
  {
    id: "deep_purple",
    name: "Deep Purple + Gold",
    description: "Premium silk branding",
    primary: "#5B2A86",
    accent: "#D4AF37",
    background: "#FCFAF7",
  },
  {
    id: "navy_saffron",
    name: "Navy + Saffron",
    description: "Trustworthy & professional",
    primary: "#1E3A8A",
    accent: "#F59E0B",
    background: "#F8FAFC",
  },
  {
    id: "burgundy_cream",
    name: "Burgundy + Cream",
    description: "Luxurious boutique",
    primary: "#7B1E3A",
    accent: "#C89B3C",
    background: "#F7F1E8",
  },
  {
    id: "vastrakiran",
    name: "VastraKiran Signature",
    description: "Logo burgundy & gold — boutique SaaS",
    primary: "#6B1D42",
    accent: "#C39D5C",
    background: "#FCF8F4",
  },
];

export function themeById(id) {
  return STORE_THEMES.find((t) => t.id === id) || STORE_THEMES[0];
}

export function storeForTheme(stores, activeStoreId) {
  if (!stores?.length) return null;
  if (activeStoreId) {
    return stores.find((s) => s.id === activeStoreId) || null;
  }
  return stores.find((s) => s.is_default) || stores[0];
}

export function applyStoreTheme(themeId) {
  const id = themeById(themeId).id;
  if (id === DEFAULT_STORE_THEME) {
    document.documentElement.removeAttribute("data-theme");
  } else {
    document.documentElement.setAttribute("data-theme", id);
  }
}

export function applyActiveStoreTheme(stores, activeStoreId) {
  const store = storeForTheme(stores, activeStoreId);
  applyStoreTheme(store?.theme || DEFAULT_STORE_THEME);
}

export function resetStoreTheme() {
  document.documentElement.removeAttribute("data-theme");
}
